import { useEffect, useState } from 'react';
import { useDeleteOrganizerMutation } from '../../Api/organizers';
import { formatPhoneNumber } from '../../Helpers/phone-formatter';
import Button from '../../Style-guide/Button';
import Input from '../../Style-guide/Input';
import Modal from '../../Style-guide/Modal';
import notify from '../../Style-guide/ToastMessage';

const organizerDetails = {
  phone: '',
  firstName: '',
  lastName: '',
};

const DeleteOrganizerModal = (props) => {
  const { isModalOpen, setIsModalOpen } = props;
  const [organizerInputs, setOrganizerInputs] = useState({ ...organizerDetails });
  const { mutate: deleteOrganizerRequest, isSuccess } = useDeleteOrganizerMutation();

  useEffect(() => {
    if (isSuccess) {
      setOrganizerInputs({ ...organizerDetails });
      setIsModalOpen(false);
    }
    /// disabled to prevent unnecessary modal bug caused by auto filled dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const formattedValue = name === 'phone' ? formatPhoneNumber(value) : value;

    setOrganizerInputs((prevFields) => ({
      ...prevFields,
      [name]: formattedValue,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const phone = organizerInputs.phone.trim();
    const firstName = organizerInputs.firstName.trim();
    const lastName = organizerInputs.lastName.trim();

    const isValid = !!phone || (!!firstName && !!lastName);

    if (!isValid) {
      notify.info('Provide either a phone number or both first and last name');

      return;
    }

    deleteOrganizerRequest({ data: organizerInputs });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <Modal
      show={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      className='delete-organizer-modal'
    >
      <Input
        type='tel'
        name='phone'
        label={`Organizer's phone number`}
        value={organizerInputs.phone}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete='off'
      />

      <Input
        type='text'
        name='firstName'
        label='First name'
        value={organizerInputs.firstName}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete='off'
      />

      <Input
        type='text'
        name='lastName'
        label='Last name'
        value={organizerInputs.lastName}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete='off'
      />

      <Button $block className='delete-organizer-btn' onClick={handleSubmit}>
        Submit
      </Button>
    </Modal>
  );
};

export default DeleteOrganizerModal;
